// extracted by mini-css-extract-plugin
module.exports = {"section":"PricingContact_section__hNwos","inner":"PricingContact_inner__4JuWQ","box":"PricingContact_box__8cxMn","title":"PricingContact_title__01esP"};